/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Office_License_BundlingInputs */

const cs_office_license_bundling = /** @type {(inputs: Office_License_BundlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licencování`)
};

const en_office_license_bundling = /** @type {(inputs: Office_License_BundlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licensing`)
};

/**
* | output |
* | --- |
* | "Licensing" |
*
* @param {Office_License_BundlingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const office_license_bundling = /** @type {((inputs?: Office_License_BundlingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Office_License_BundlingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_office_license_bundling(inputs)
	return cs_office_license_bundling(inputs)
});